import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchCrmAbTestTypes = async (): Promise<string[]> => {
  const response = await queryExecute({
    query: graphql(`
      query CrmAbTestTypes {
        crmAbTestTypes
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.crmAbTestTypes;
};
